import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { Intake, Patient } from '../models';
import { Api, Session } from '../services/index';
import { MyModal } from '../components/modal/modal';

@Component({
  selector: 'app-bh-prescription-policy',
  templateUrl: './bh-prescription-policy.html'
})



export class BHPrescriptionPolicy  {
  constructor(private router: Router) {   }
  
  requestExam(){
		this.router.navigateByUrl('/exam-request-care-today');
  }
  
  gotoDashboard() {
		this.router.navigate(['/dashboard-medical/2']);
  }
  
}